import React from "react";
import { truncatePathWithSegments } from "../utils/displayPathTruncator";
import { LibraryEntity } from "../types";

interface ContentCardProps {
  entity: LibraryEntity;
  query: string;
  onClick: (entity: LibraryEntity) => void;
  highlightSearchTerm: (text: string, searchTerm: string) => React.ReactNode;
  showTypeLabel?: boolean;
}

const getEntityTypeLabel = (type: string): string => {
  switch (type) {
    case "event":
      return "Event";
    case "album":
      return "Album";
    case "folder":
      return "Folder";
    default:
      return "";
  }
};

const ContentCard: React.FC<ContentCardProps> = ({
  entity,
  query,
  onClick,
  highlightSearchTerm,
  showTypeLabel = false
}) => {
  return (
    <div
      className="enhanced-search-result-item"
      onClick={() => onClick(entity)}
      aria-label={`Navigate to ${entity.type} ${entity.name}`}
    >
      <div className="unified-search-content-name">
        {highlightSearchTerm(entity.name, query)}
        {showTypeLabel && (
          <span className="unified-search-content-type-label">
            {getEntityTypeLabel(entity.type)}
          </span>
        )}
      </div>
      <div className="unified-search-content-path">
        Library
        {entity.path && entity.path.length > 0 && (
          <> / {truncatePathWithSegments(entity.path)}</>
        )}
      </div>
      {entity.createdAt && (
        <div className="unified-search-content-date">
          {new Date(entity.createdAt).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          })}
        </div>
      )}
    </div>
  );
};

export default ContentCard;
